export const PAST_ONE_YEAR_IOF_FEE = 1.5 / 100;
export const PAST_ONE_YEAR_SIMPLES_NACIONAL_IOF_FEE = 0.5 / 100;
export const DEFAULT_DAYLY_IOF_FEE = 0.0041 / 100;
export const SIMPLES_NACIONAL_DAYLY_IOF_RATE = 0.00137 / 100;
export const REQUESTED_AMOUNT_FEE = 0.38 / 100;
export const REQUESTED_AMOUNT_LIMIT_TO_SIMPLES_NACIONAL = 30000;